module.exports = __webpack_public_path__ + "static/img_1-c8a5e22b16ea5c4819f386612441502f.png";